export const rateFormatter = (rate: number) => {
  return rate.toFixed(2).replace('.', ',') + '%';
};
